<div class="status__content">
	<p>
		<span>{{ cellValue.message }}</span>
	</p>
</div>
